var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M903 929.5H132.5c-20.1 0-36.5-16.4-36.5-36.6V119.5c0-13.8 11.2-25 25-25s25 11.2 25 25v760h757c13.8 0 25 11.2 25 25s-11.2 25-25 25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M241 536.7h50V796h-50zM417.7 458.5h50V796h-50zM594.3 536.7h50V796h-50zM771 411h50v385h-50zM246.9 467.2L217 426.8l218.9-156.9 185.8 114.3 182.8-150.4 32.5 38.4-211 173.6-187.9-115.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M715.2 184.2l194.6-3.9-43.9 187"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.98f024dc6c02b8ee469e99d1099eaf5e.svg";
export { ForwardRef as ReactComponent };